import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  BID_ANALYSIS_FOOTNOTES,
  BID_ANALYSIS_INFO,
  COLOR_ALL_JOBS,
} from 'components/reports/Metrics/constants/BidAnalysis'

import { BidAnalysisCards } from './BidAnalysisCards'
import { BidAnalysisFilterCriteria } from './BidAnalysisFilterCriteria'
import { BidAnalysisFiltersForm } from './BidAnalysisFilters'

export const BidAnalysis = () => (
  <BidAnalysisFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
              Bidding &amp; Response Times
            </Typography>
            <Tooltip
              title={BID_ANALYSIS_INFO}
              slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 420 } } }}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            Understand bidding competitiveness and response times across the network.
          </Typography>
        </Box>

        <BidAnalysisFiltersForm />
      </Stack>

      <BidAnalysisCards />

      <Box
        sx={{
          mt: 3,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(COLOR_ALL_JOBS, 0.04),
          border: 1,
          borderColor: alpha(COLOR_ALL_JOBS, 0.2),
        }}>
        <Stack direction='row' spacing={1.25} alignItems='flex-start'>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: COLOR_ALL_JOBS, mt: 0.25 }} />
          <Box>
            {BID_ANALYSIS_FOOTNOTES.map((line) => (
              <Typography
                key={line}
                variant='caption'
                color='text.secondary'
                display='block'
                sx={{ lineHeight: 1.7 }}>
                {line}
              </Typography>
            ))}
          </Box>
        </Stack>
      </Box>
    </Box>
  </BidAnalysisFilterCriteria>
)
